import * as React from 'react';
const SvgExpand = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 12 12" fill="none" {...props}>
        <path
            d="M9.225 2.092v-.243l-.862.236c-.404.11-.82.165-1.238.165a.728.728 0 01-.75-.75.75.75 0 01.75-.75H10.5a.75.75 0 01.75.75v3.378a.75.75 0 01-.75.75.73.73 0 01-.75-.75c0-.42.056-.838.166-1.242l.235-.86h-.24l-.808 1.078a7.501 7.501 0 01-.698.804l-.752.751a.75.75 0 11-1.06-1.06l.753-.753c.248-.249.516-.48.797-.692l1.082-.812zm-6.45 7.813v.243l.863-.236c.403-.11.819-.166 1.237-.166.45 0 .75.335.75.75a.75.75 0 01-.75.75H1.5a.75.75 0 01-.75-.75V7.12a.75.75 0 01.75-.75.73.73 0 01.75.75c0 .42-.056.837-.167 1.242l-.234.86h.24l.808-1.077a7.57 7.57 0 01.698-.804l.752-.752a.75.75 0 011.06 1.06l-.753.754c-.249.249-.516.48-.797.692l-1.082.811z"
            fill="currentColor"
        />
    </svg>
);
export default SvgExpand;
